import React from 'react';
import ReactDOM from 'react-dom';
import App from './_app/App';
import * as serviceWorker from './serviceWorker';
import 'react-table/react-table.css';
import 'react-notifications-component/dist/scss/notification.scss';
import 'animate.css/animate.min.css';
import 'antd/lib/date-picker/style/css';
import 'rc-tree-select/assets/index.css';
import './_css/style.scss';
import './_css/fonts/fonts.css'
import './_css/basscss.min.css';
import './_helpers/service';

ReactDOM.render(<App/>, document.getElementById('root'));
serviceWorker.unregister();
